import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "@mui/material";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import VotingPage from "./pages/VotingPage";
import ResultsPage from "./pages/ResultsPage";
import VoteSuccessPage from "./pages/VoteSuccessPage";
import ArtistsGridPage from "./pages/ArtistsGridPage";
import RealTimeMonitorPage from "./pages/RealTimeMonitorPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import SchedulePage from "./pages/SchedulePage";
import FantaSanremoPage from "./pages/FantaSanremoPage";
import ProtectedRoute from "./components/ProtectedRoute";
import EventsHomePage from "./pages/EventsHomePage";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <EventsHomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey"
            element={
              <ProtectedRoute>
                <ArtistsGridPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/schedule"
            element={
              <ProtectedRoute>
                <SchedulePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schedule"
            element={
              <ProtectedRoute>
                <SchedulePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/voting"
            element={
              <ProtectedRoute>
                <VotingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/voting"
            element={
              <ProtectedRoute>
                <VotingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/vote-success"
            element={
              <ProtectedRoute>
                <VoteSuccessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vote-success"
            element={
              <ProtectedRoute>
                <VoteSuccessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/artists"
            element={
              <ProtectedRoute>
                <ArtistsGridPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/artists"
            element={
              <ProtectedRoute>
                <ArtistsGridPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/results"
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/results"
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/monitor"
            element={
              <ProtectedRoute>
                <RealTimeMonitorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor"
            element={
              <ProtectedRoute>
                <RealTimeMonitorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:eventKey/fanta"
            element={
              <ProtectedRoute>
                <FantaSanremoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fanta"
            element={
              <ProtectedRoute>
                <FantaSanremoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Container>
    </div>
  );
}

export default App;
